<!--
部门管理
-->
<template>
	<div class="box-page">
		<div class="flex-c-s mb20">
			<div class="box-title">部门管理</div>
			<div class="box-btn" v-if="btns['add-department']" @click="openAdd">
				<img src="@/assets/images/btn_add_icon.png" width="12" height="12" />
				<span>新增部门</span>
			</div>
		</div>

		<div class="my-table">
			<el-table :data="list" width="100%" row-key="deptId" :tree-props="{ children: 'nextDeptList' }"
				v-loading="loading">
				<el-table-column label="部门名称" prop="deptName" show-overflow-tooltip></el-table-column>
				<el-table-column prop="deptUserCount" label="部门人数" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" width="140">
					<template slot-scope="scope">
						<div class="row-btns">
							<el-tooltip class="item" effect="dark" content="编辑" placement="top">
								<img src="@/assets/images/yggl_icon_bj.png" v-if="btns['update-department']"
								@click="openUpdate(scope.row.deptId)" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="查看员工" placement="top">
								<img src="@/assets/images/home_icon_ck.png" v-if="btns['view-department']"
								@click="openUser(scope.row.deptId)" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="删除" placement="top">
								<img src="@/assets/images/yggl_icon_sc.png" v-if="btns['del-department']"
								@click="openDel(scope.row.deptId)" />
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
				@current-change="getDeptList" class="box-paging">
			</el-pagination>
		</div>

		<el-dialog :title="dialogType == '1' ? '新增部门' : '编辑部门'" :visible.sync="dialogVisible"
			:close-on-click-modal="false" v-el-drag-dialog width="30%" @close="changeClose">
			<el-form :model="form" :rules="rules" label-width="90px" ref="formRef" v-loading="dialogLoading">
				<el-form-item label="部门名称" prop="deptName">
					<el-input v-model="form.deptName" placeholder="请输入部门名称"></el-input>
				</el-form-item>
				<el-form-item label="上级部门" prop="upDeptId">
					<el-cascader v-model="form.upDeptId" :options="dialogType == '1' ? list : selectList" :props="{
              label: 'deptName',
              value: 'deptId',
              children: 'nextDeptList',
              checkStrictly: true,
            }" :show-all-levels="false" clearable style="width: 100%" ref="cascader"></el-cascader>
				</el-form-item>
				<div class="flex-row-center">
					<div class="box-btn" style="width: 290px" @click="handleDepartment">
						确认{{ dialogType == '1' ? '新增' : '修改' }}
					</div>
				</div>
			</el-form>
		</el-dialog>

		<department-user-list @refresh="getDeptList" ref="depUserList"></department-user-list>
	</div>
</template>

<script>
	import DepartmentUserList from '@/components/Department/DepartmentUserList.vue'

	export default {
		components: {
			DepartmentUserList
		},
		data() {
			return {
				list: [], // 部门列表
				page: 1,
				total: 1,
				loading: false,

				selectList: [], // 编辑时选则的上级部门列表 不包含自身部门
				nowId: '', // 当前编辑的部门id

				dialogVisible: false,
				dialogType: '', // 1 新增 2 编辑
				dialogLoading: false,

				form: {
					deptName: '',
					upDeptId: ''
				},

				rules: {
					deptName: {
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}
				}
			}
		},
		computed: {
			// 按钮权限
			btns() {
				return this.$route.meta.btns
			}
		},
		watch: {},
		mounted() {
			this.getDeptList()
		},
		methods: {
			// 获取部门列表
			getDeptList() {
				this.loading = true
				this.$api.organization
					.deptList({
						keyword: '',
						limit: 10,
						page: this.page
					})
					.then(({
						data
					}) => {
						this.loading = false
						if (data.code == 200) {
							this.list = data.data
							this.total = data.total
						}
					})
					.catch(() => {
						this.loading = false
					})
			},

			// 打开新增
			openAdd() {
				this.dialogType = '1'
				this.dialogVisible = true
			},

			// 打开编辑
			openUpdate(id) {
				this.dialogType = '2'
				this.dialogVisible = true
				this.nowId = id
				this.dialogLoading = true
				this.selectList = JSON.parse(JSON.stringify(this.list))
				this.getSelectList(this.selectList)
				this.$api.organization
					.deptDetail(id)
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							this.form = data.data
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 获取所有不包含自身的部门列表
			getSelectList(data) {
				data.forEach((item) => {
					if (item.deptId == this.nowId) {
						item.disabled = true
					}
					if (item.nextDeptList && item.nextDeptList.length > 0) {
						this.getSelectList(item.nextDeptList)
					}
				})
			},

			// 处理编辑 新增
			handleDepartment() {
				this.$refs.formRef.validate((valid) => {
					if (valid) {
						if (this.form.upDeptId.length >= 3) {
							this.$notify.error({
								title: '提示',
								message: '当前部门分级最大三级'
							})
							return
						}
						this.dialogType == '1' ? this.handleAdd() : this.handleUpdate()
					} else return false
				})
			},

			// 确认编辑
			handleUpdate() {
				this.dialogLoading = true
				const nodes = this.$refs.cascader.getCheckedNodes()[0]
				const upDeptId = nodes ? nodes.value : ''
				this.$api.organization
					.editDept({
						deptId: this.nowId,
						name: this.form.deptName,
						upDeptId
					})
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							this.$notify.success({
								title: '提示',
								message: '修改成功'
							})
							this.dialogVisible = false
							this.getDeptList()
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 确认新增
			handleAdd() {
				this.dialogLoading = true
				const nodes = this.$refs.cascader.getCheckedNodes()[0]
				const upDeptId = nodes ? nodes.value : ''
				this.$api.organization
					.addDept({
						name: this.form.deptName,
						upDeptId
					})
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							this.$notify.success({
								title: '提示',
								message: '新增成功'
							})
							this.dialogVisible = false
							this.getDeptList()
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 打开部门员工列表
			openUser(id) {
				const showBtn = this.btns['del-user']
				this.$refs.depUserList.open(id, showBtn)
			},

			// 删除
			openDel(id) {
				this.$confirm('此操作将删除该部门信息, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$api.organization.deleteDept(id).then(({
							data
						}) => {
							if (data.code == 200) {
								if (this.total % 10 == 1 && this.page != 1) this
									.page-- // 若当前删除的为当前页最后一个 则page-1
								this.$notify.success({
									title: '提示',
									message: '删除成功'
								})
								this.getDeptList()
							}
						})
					})
					.catch(() => {})
			},

			changeClose() {
				this.$refs.formRef.resetFields()
			}
		}
	}
</script>
<style lang="scss" scoped></style>
